// extracted by mini-css-extract-plugin
export default {"storeContainer":"Store_storeContainer__j11Vl","storeBox":"Store_storeBox__CdR+8"};